<template>
    <div class="bankTransfer">
      <div class="bankTransfer-desc">Please use our bank details below that correspond to the base currency of your trading account. You may complete the transfer at your
local bank or via your bank's online banking services.</div>
      <div class="bankTransfer-tab">
        <ul class="bankTransfer-nav">
          <li @click="curIndex=index" :class="{'on':curIndex===index}" v-for="(item,index) in bankTransferNav" v-html="item" :key="index"></li>
        </ul>
        <div class="bankTransfer-cons">
          <div class="bankTransfer-con" v-show="curIndex===0">
            <div class="bankTransfer-Details">USD Deposit Bank Account Details</div>
            <dl>
              <dt>Bank Name</dt>
              <dd>Revolut Ltd</dd>
            </dl>
            <dl>
              <dt>Bank Address</dt>
              <dd>7 Westferry Circus, The Columbus Building, 4th Floor, London, E14 4HD, United Kingdom</dd>
            </dl>
            <dl>
              <dt>Beneficiary</dt>
              <dd>Zeal Capital Market (UK) Limited</dd>
            </dl>
            <dl>
              <dt>BIC/SWIFT</dt>
              <dd>REVOGB21</dd>
            </dl>
            <dl>
              <dt>Intermediary BIC</dt>
              <dd>CHASGB2L</dd>
            </dl>
            <dl>
              <dt>IBAN</dt>
              <dd>GB09REVO00996951133739</dd>
            </dl>
            <div class="bankTransfer-con-tips">Please add reference or short note to your bank transfer. E.g. for Mr John Smith, who has a Standard Trading Account number: 12345, should put "STD12345JOHNSMITH".</div>
          </div>
         <!-- <div class="bankTransfer-con" v-show="curIndex===1">
            <div class="bankTransfer-Details">EUR Deposit Bank Account Details</div>
            <dl>
              <dt>Bank Name</dt>
              <dd>Barclays Bank Plc</dd>
            </dl>
            <dl>
              <dt>Bank Address</dt>
              <dd>1 Churchill Place, Canary Wharf, London, E14 5HP, United Kingdom</dd>
            </dl>
            <dl>
              <dt>Beneficiary</dt>
              <dd>Zeal Client EUR</dd>
            </dl>
            <dl>
              <dt>Sort Code</dt>
              <dd>20-32-06</dd>
            </dl>
            <dl>
              <dt>Account Number:</dt>
              <dd>87755811</dd>
            </dl>
            <dl>
              <dt>BIC / SWIFT</dt>
              <dd>BUKBGB22</dd>
            </dl>
            <dl>
              <dt>IBAN</dt>
              <dd>GB08BUKB20320687755811</dd>
            </dl>
            <div class="bankTransfer-con-tips">Please add reference or short note to your bank transfer. E.g. for Mr John Smith, who has a Standard Trading Account number: 12345, should put "STD12345JOHNSMITH".</div>
          </div>-->
          <div class="bankTransfer-con" v-show="curIndex===1">
            <div class="bankTransfer-Details">GBP Deposit Bank Account Details</div>
            <dl>
              <dt>Bank Name</dt>
              <dd>Revolut Ltd</dd>
            </dl>
            <dl>
              <dt>Bank Address</dt>
              <dd>7 Westferry Circus, The Columbus Building, 4th Floor, London, E14 4HD, United Kingdom</dd>
            </dl>
            <dl>
              <dt>Beneficiary</dt>
              <dd>Zeal Capital Market (UK) Limited</dd>
            </dl>
            <dl>
              <dt>Sort Code</dt>
              <dd>04-00-75</dd>
            </dl>
            <dl>
              <dt>Account Number:</dt>
              <dd>82509298</dd>
            </dl>
            <dl>
              <dt>BIC/SWIFT</dt>
              <dd>REVOGB21</dd>
            </dl>
            <dl>
              <dt>IBAN</dt>
              <dd>GB09REVO00996951133739</dd>
            </dl>
            <div class="bankTransfer-con-tips">Please add reference or short note to your bank transfer. E.g. for Mr John Smith, who has a Standard Trading Account number: 12345, should put "STD12345JOHNSMITH".</div>
          </div>
        </div>
      </div>
      <dl class="bankTransfer-tips">
        <dt>Note: </dt>
        <dd>We do not accept funds transfers made by a third party other than from the Trading Account holder, or funds will be rejected and fees may incur. </dd>
      </dl>
    </div>
</template>

<script>
export default {
  data() {
    return {
      bankTransferNav: ['USD  Deposits', 'GBP  Deposits'],
      curIndex: 0
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
.bankTransfer {
  margin-right: 40px;

  &-desc {
    line-height: 19px;
    color: #888888;
    margin-top: 39px;
  }
  &-tab {
    margin-top: 30px;
  }
  &-nav {
    float: left;
    li {
      width: 144px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      background-color: #f5f5f5;
      border-bottom: 1px solid #fff;
      cursor: pointer;
      &.on {
        border-left: 4px solid $color-primary;
        color: #0A95FF;
        background-color: #fffbf8;
      }
    }
  }
  &-cons {
    margin-left: 144px;
  }
  &-con {
    min-height: 422px;
    padding: 27px 30px;
    background-color: #fffbf8;
    dl {
      margin-top: 30px;
    }
    dt {
      color: #888888;
      float: left;
    }
    dd {
      color: #444444;
      margin-left: 160px;
    }
    &-tips {
      margin-top: 30px;
      color: $color-primary;
    }
  }
  &-tips {
    dt {
      margin-bottom: 10px;
    }
    dd {
      position: relative;
      padding-left: 10px;
      &:before {
        content: '*';
        color: $color-primary;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        font-size: 12px;
        line-height: 24px;
      }
    }
  }
}
</style>
